var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.length == 0)?_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"colspan":"40"}},[_vm._v(_vm._s(_vm._traducao('global', 'nenhumRegistroEncontrado'))+".")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }